"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSpuParam = void 0;
/* eslint-disable no-param-reassign */
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const useStatic_1 = require("../_hooks/useStatic");
const useSubject_1 = require("../_hooks/useSubject");
const useImportValues_1 = require("./useImportValues");
function useSpuParam({ paramList }, importValues) {
    const emptyObject = (0, useStatic_1.useEmptyObject)();
    const { importValues$ } = (0, useImportValues_1.useImportValues)({ paramList }, importValues);
    const [currentValues, setCurrentValues, currentValues_] = (0, useSubject_1.useImmerBehaviorSubject)(emptyObject);
    const [importedValues, setImportedValues, importedValues_] = (0, useSubject_1.useImmerBehaviorSubject)(emptyObject);
    const [defaultValues, setDefaultValues, defaultValues_] = (0, useSubject_1.useImmerBehaviorSubject)(emptyObject);
    const [paramBehavior, setParamBehavior, paramBehavior_] = (0, useSubject_1.useImmerBehaviorSubject)(emptyObject);
    // 换商品了，全部清空
    (0, react_1.useEffect)(() => {
        setCurrentValues({});
        setDefaultValues({});
        setParamBehavior({});
    }, [setCurrentValues, setDefaultValues, setParamBehavior, paramList]);
    // 设置默认值
    (0, react_1.useEffect)(() => {
        const subscription = importValues$
            .pipe((0, rxjs_1.filter)((values) => values !== null))
            .subscribe({
            next: setImportedValues,
        });
        return () => {
            subscription.unsubscribe();
        };
    }, [importValues$, setImportedValues]);
    const effectiveValues_ = (0, react_1.useMemo)(() => (0, rxjs_1.combineLatest)([currentValues_, importedValues_, defaultValues_, paramBehavior_]).pipe((0, rxjs_1.map)(([currentValues, importedValues, defaultValues, paramBehavior]) => {
        var _a, _b, _c;
        const result = {};
        for (const key of Object.keys(paramBehavior)) {
            const { isVisible, isCalculable } = paramBehavior[key];
            if (isVisible) {
                (_a = result[key]) !== null && _a !== void 0 ? _a : (result[key] = (_b = currentValues[key]) !== null && _b !== void 0 ? _b : importedValues[key]);
            }
            if (isCalculable) {
                (_c = result[key]) !== null && _c !== void 0 ? _c : (result[key] = defaultValues[key]);
            }
        }
        return result;
    })), [currentValues_, importedValues_, defaultValues_, paramBehavior_]);
    const getFlatValues = (0, react_1.useCallback)(() => __awaiter(this, void 0, void 0, function* () { return yield (0, rxjs_1.firstValueFrom)(effectiveValues_); }), [effectiveValues_]);
    const effectiveValues = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        const result = {};
        for (const key of Object.keys(paramBehavior)) {
            const { isVisible, isCalculable } = paramBehavior[key];
            if (isVisible) {
                (_a = result[key]) !== null && _a !== void 0 ? _a : (result[key] = (_b = currentValues[key]) !== null && _b !== void 0 ? _b : importedValues[key]);
            }
            if (isCalculable) {
                (_c = result[key]) !== null && _c !== void 0 ? _c : (result[key] = defaultValues[key]);
            }
        }
        return result;
    }, [currentValues, importedValues, defaultValues, paramBehavior]);
    return {
        effectiveValues,
        setCurrentValues,
        setImportedValues,
        setDefaultValues,
        setParamBehavior,
        getFlatValues,
        currentValues_,
        effectiveValues_,
    };
}
exports.useSpuParam = useSpuParam;
